// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"5200":"wix-i18n-config_intl-pluralrules","6169":"doppe-viewer-api-routes-manager","6763":"doppe-viewer-wix-web-bi-logger","6894":"wix-i18n-config_intl-relativetimeformat","9417":"doppe-action-type-auto-blog-post-widget","9505":"doppe-action-type-articles-list-widget"}[chunkId] || chunkId) + ".bundle.js";
};